import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, NgZone, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule, NgClass, NgOptimizedImage, NgStyle, SlicePipe } from '@angular/common';
import { DateAdapter } from '@angular/material/core';
import { ProductService } from '../../services/product.service';
import { VideoBannerSearchComponent } from './video-banner-search/video-banner-search.component';
import { environment } from '../../../environments/environment.prod';
import { Constant } from '../../../constants/constant';
import { CommonService } from '../../services/common.service';
import { UserService } from '../../services/user.service';
import { CartService } from '../../services/cart.service';
import { DefaultLayoutDirective } from '../../flex-layout/custom-layout';
import { DefaultLayoutAlignDirective } from '../../flex-layout/custom-layout-align';
import { DefaultLayoutGapDirective } from '../../flex-layout/custom-layout-gap';
import { DefaultFlexAlignDirective } from '../../flex-layout/flex-align';
import { DefaultShowHideDirective } from '../../flex-layout/show-hide';
import { DefaultStyleDirective } from '../../flex-layout/style';
import { AnimatedScrollReviewComponent } from './animated-scroll-review/animated-scroll-review.component';
import { AnimatedTextComponent } from './animated-text/animated-text.component';
import { ContentAnimDirective } from '../product-layout/content-anim.directive';
import { BrandsComponent } from '../../home/brands/brands.component';
import { Zigzagimage1Component } from './zigzagimage1/zigzagimage1.component';
import { ButtonRowHeaderComponent } from './button-row-header/button-row-header.component';
import { AnimateScrollTwoComponent } from './animate-scroll-two/animate-scroll-two.component';
import { FaqComponent } from './faq/faq.component';
import { EditorTextComponent } from './editor-text/editor-text.component';
import { MatButton, MatAnchor, MatIconButton, MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { DefaultClassDirective } from '../../flex-layout/class';
import { CustomFlexLayoutModule } from '../../flex-layout/custom-flex-layout.module';
import { DefaultFlexDirective } from '../../flex-layout/flex';
import { FooterlayoutComponent } from './footerlayout/footerlayout.component';
import { ConfigServiceService } from '../../services/config-service.service';
import { AboutService } from '../../services/about.service';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AnalyticService } from '../../services/analytic.service';
import { MatDialog } from '@angular/material/dialog';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { PlanCompareComponent } from './plan-compare/plan-compare.component';
import { BrandscarouselType27Component } from './brandscarousel-type27/brandscarousel-type27.component';
import { SafePipe } from '../pipes/safe.pipe';
import { MobileiconComponent } from './mobileicon/mobileicon.component';
import { ContactFormComponent } from './contact-form/contact-form.component';
import { ImageContactFormComponent } from './image-contact-form/image-contact-form.component';
import { TextwithimageComponent } from './textwithimage/textwithimage.component';
import { Router } from '@angular/router';
import { AnimatedScrollComponent } from './animated-scroll/animated-scroll.component';
import { VedioLayoutComponent } from './vedio-layout/vedio-layout.component';
import { TextWithTextComponent } from './text-with-text/text-with-text.component';
import { NewBannerComponent } from './new-banner/new-banner.component';
import { BannerOverContentComponent } from './banner-over-content/banner-over-content.component';
import { TabLayoutComponent } from './tab-layout/tab-layout.component';
import { DoubleimageformComponent } from './doubleimageform/doubleimageform.component';
import { BlogSectionComponent } from '../../home/blog-section/blog-section.component';
import { NgOptimizedImageComponent } from './ng-optimized-image/ng-optimized-image.component';
import { Bannertextwithimage2Component } from './bannertextwithimage2/bannertextwithimage2.component';
import { BannertextwithimageComponent } from './bannertextwithimage/bannertextwithimage.component';
import { FormPopupComponent } from './form-popup/form-popup.component';
import { HomeBannerLayoutComponent } from './home-banner-layout/home-banner-layout.component';
import { ComparisonComponent } from './comparison/comparison.component';
import { PlanCompareType11Component } from './plan-compare-type11/plan-compare-type11.component';
import { ButtonType1Component } from './button-type1/button-type1.component';
import { StepflowLayoutComponent } from './stepflow-layout/stepflow-layout.component';
import { PlanCompareType2Component } from './plan-compare-type2/plan-compare-type2.component';


declare var window: any;
@Component({
  selector: 'calsoft-layout',
  imports: [NgClass, NgStyle,
    MatIcon,
    MatButton,
    MatAnchor,
    MatIconButton,
    DefaultStyleDirective,
    DefaultLayoutDirective,
    DefaultShowHideDirective,
    DefaultLayoutAlignDirective,
    DefaultLayoutGapDirective,
    DefaultFlexAlignDirective,
    DefaultFlexDirective,
    DefaultClassDirective,
    CustomFlexLayoutModule,
    VideoBannerSearchComponent,
    AnimatedScrollReviewComponent,
    AnimatedTextComponent,
    ContentAnimDirective,
    BrandsComponent,
    Zigzagimage1Component,
    FooterlayoutComponent,
    ButtonRowHeaderComponent,
    AnimateScrollTwoComponent,
    FaqComponent,
    EditorTextComponent,
    InfiniteScrollDirective,
    MatProgressSpinnerModule,
    FooterlayoutComponent,
    CarouselModule,
    PlanCompareComponent,
    BrandscarouselType27Component,
    NgOptimizedImageComponent,
    SafePipe,
    MobileiconComponent,
    ContactFormComponent,
    ImageContactFormComponent,
    TextwithimageComponent,
    CommonModule,
    AnimatedScrollComponent,
    VedioLayoutComponent,
    TextWithTextComponent,
    NewBannerComponent,
    BannerOverContentComponent,
    TabLayoutComponent,
    DoubleimageformComponent,
    BlogSectionComponent,
    Bannertextwithimage2Component,
    BannertextwithimageComponent,
    HomeBannerLayoutComponent,
    ComparisonComponent,
    PlanCompareType11Component,
    ButtonType1Component,
    MatButtonModule,
    StepflowLayoutComponent,
   PlanCompareType2Component
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutComponent implements OnInit ,OnChanges{
  //Declaration
  @Input() value: any;


  public serverPath = environment.commonImageApi + '/home/';

  public serverPath1 = environment.commonImageApi + '/commonSlider/';

  @Input() homePageData: any;
  dataLoaded: boolean = false;

  @Input() type: any = 1;
  recentlyViewedProducts: Object | undefined;
  mobileLayout: any = false;

  @Input() pageNated: any = false;
  @Input() data: any;
  public page: any = 0;
  public size: any = 3;
  homePageProduct: any = [];
  pageSize: any;

  featuredProducts: any;
  onSaleProducts: any;
  topRatedProducts: any;
  newArrivalsProducts: any;
  customField17: any;
  customField18: any;

  mediaGallery: any;
  sortParam: any = 'id' + ',' + Constant.Dsc;


  public youtubeUrl = environment.youtubeUrl;
  spinner: boolean = false;
  slides: any = [];
  empty: any;
  layout: any;
  totalNumberOfElements: any;
  showCartIcon: any;
  showCartIncremented: any;
  showConfigurableDropdown: any;
  productImageWidth: any;
  productImageType: any;
  productImageWidthMob: any;
  productImageHeightMob: any;
  categoryArray: any = [];
  bannerHeight: any;
  bannerWidth: any;
  bannerMobWidth: any;
  bannerMobHeight: any;
  bannerTabletHeight: any;
  bannerTabletWeight: any;
  dataLoaed: any = false;
  fontFamily: string | undefined;
  height: any;
  width: any;
  gapBetweenImage: any;
  @Input() item: any;
  customField12: any;
  customField11: any;
  customField13: any = 0;
  customField14: any;
  customField19: any;
  customField20: any = 0;
  heightMob: any;
  widthMob: any;
  displayMobileImage: any;
  mobileGapBetweenImage: any;
  altImage: any;
  autoplay: any = 0;
  homePageLayoutLoadedWeb: any;
  homePageLayoutLoadedMob: any;
  total: number | undefined;
  browserGraphImage: string | undefined;
  keywords: string | undefined;
  author: string | undefined;
  description: string | undefined;
  staticLinkdlnId: any;
  productImageHeight: any;
  hovering: boolean = false;
  slicedImages: any;
  typeCastedImages: any[] = [];
  img:any; 
  constructor(
    private zone: NgZone,
    private cdr: ChangeDetectorRef,
    public router: Router,
    private cartServices: CartService,
    private userService: UserService,
    private configService: ConfigServiceService,
    private productService: ProductService,
    private commonService: CommonService,
    private aboutService: AboutService,
    private analyticService: AnalyticService,
    public dialog: MatDialog,
  ) {

  }
  ngOnChanges(changes: SimpleChanges): void {

    
  }

  ngOnInit() {
        this.checkDeviceType();
    this.getConfigData();
    //for item.image use this 
    this.typeCastedImages = (this.item?.images || []);
  }
  isLowEndMobile: boolean | any = false;
  mobileLayoutTwo: boolean = false;
  checkDeviceType() {
   
    this.mobileLayoutTwo = window.innerWidth <= 768; 
    const userAgent = navigator.userAgent || navigator.vendor;
    this.isLowEndMobile =
      this.mobileLayoutTwo &&
      (/Android.*Mobi/i.test(userAgent) || /iPhone/i.test(userAgent)) &&
      (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4); 
  }
  getConfigData() {
    this.configService.getConfigData()
      .subscribe(
        (data: any) => {

          this.commonService.setCurrencyValue(data['currencyBase'])
          this.showCartIcon = data['showCartProductPage'];

          this.showCartIncremented = data['showCartIncremented'];
          this.staticLinkdlnId = data['linkedinConversationId'];


          this.showConfigurableDropdown = data['showConfigurableDropdownProductPage'];
          this.productImageHeight = data['productsImageHeight']
          this.productImageWidth = data['productsImageWidth']
          this.data = data;
          this.productImageType = data['productsImageType']
          this.productImageWidthMob = data['productsImageWidthMob']
          this.bannerHeight = data['bannerHeight'];
          this.bannerWidth = data['bannerWidth'];
          this.bannerMobWidth = data['bannerMobWidth'];
          this.bannerMobHeight = data['bannerMobHeight'];
          this.homePageLayoutLoadedMob = data['homePageLayoutLoadedMob'];
          this.homePageLayoutLoadedWeb = data['homePageLayoutLoadedWeb'];
          this.productImageHeightMob = data['productsImageHeightMob'];
          this.author = data['author'];
          this.description = data['description'];
          this.keywords = data['keywords'];
          this.browserGraphImage = data['browserGraphImage'];

          console.log("the typ is",this.type);
          
          if (this.type == 1) {
            this.getHomePage();

          } else {
            this.homePageProduct = this.homePageData;

            if (this.pageNated) {
              this.pageSize = this.homePageData[0]['pageSize']

              this.totalNumberOfElements = this.homePageData[0]['totalNumberOfElements'] - 1;

              this.total = this.homePageData[0]['totalElements'] - 1;
            }


          }

          if (this.height !== undefined) {
            this.height = this.item.height;
          }

          if (this.width !== undefined) {
            this.width = this.item.width;
          }

          if (this.widthMob !== undefined) {
            this.widthMob = this.item.widthMob;
          }

          if (this.heightMob !== undefined) {
            this.heightMob = this.item.heightMob;
          }

          if (this.gapBetweenImage !== undefined) {
            this.gapBetweenImage = this.item.gapBetweenImage;
          }

          if (this.mobileGapBetweenImage !== undefined) {
            this.mobileGapBetweenImage = this.item.mobileGapBetweenImage;
          }

          if (this.displayMobileImage !== undefined) {
            this.displayMobileImage = this.item.displayMobileImage;
          }

          let authourized = this.userService.getAuthenticatedUser();
          if (authourized) {
            this.cartServices.getCustomerCartProductCount()
            this.cartServices.geWishListProduct();
          }

        }, () => {

        }
      );
  }
  onScroll() {

    if (window.innerWidth > 768) {

      this.mobileLayout = false;
      this.size = this.homePageLayoutLoadedWeb == undefined ? 3 : this.homePageLayoutLoadedWeb;
    } else {
      this.mobileLayout = true;
      this.size = this.homePageLayoutLoadedMob == undefined ? 5 : this.homePageLayoutLoadedMob;
    }


    if (this.type === 1) {
      if (this.page < this.pageSize) {
        this.spinner = true;
        this.page++;
        this.productService.getHomePageProduct(this.page, this.size, this.value).subscribe(
          (res: any) => {
            // Append products to the array
            const products = res['data']['content']
            this.homePageProduct.push(...products);
            this.homePageProduct.sort((a: any, b: any) => a.position - b.position);
            this.spinner = false;

            // Check if no products are returned
            if (this.homePageProduct.length < 1) {
              console.warn("No products found.");
            }
          },
          error => {
            console.error("Error loading products:", error);
            this.spinner = false; // Reset spinner on error
          }
        );
      } else {
        this.spinner = false;
      }
    } else if (this.pageNated && this.type === 2) {
      if (this.page < this.pageSize) {
        this.spinner = true;
        this.page++;
        let value = this.homePageProduct[0].uuid;
        this.aboutService.getPageByUUid(value, this.page, this.size).subscribe(
          (res: any) => {
            const products = res || [];
            if (products.length === 0) {
            } else {
              this.homePageProduct.push(...products);
              this.homePageProduct.sort((a: any, b: any) => a.position - b.position);

            }
            this.spinner = false;
          },
          (error: any) => {
            console.error("Error loading products:", error);
            this.spinner = false;
          }
        );
      } else {
        this.spinner = false;
      }
    }

  }
    stripHtmlTags(value: string | undefined): string {
    return value ? value.replace(/<\/?[^>]+(>|$)/g, "") : "";
  }

  getHomePage() {

    this.page = 0;
    console.log("the homepageLayoutloaded web is",this.homePageLayoutLoadedMob);
    
    if (window.innerWidth > 768) {

      this.mobileLayout = false;
      this.size = this.homePageLayoutLoadedWeb == undefined ? 3 : this.homePageLayoutLoadedWeb;
    } else {
      this.mobileLayout = true;
      this.size = this.homePageLayoutLoadedMob == undefined ? 5 : this.homePageLayoutLoadedMob;
    }
    console.log("the page is",this.page);
    console.log("The size is ",this.size);
    
    
    this.productService.getHomePageProduct(this.page, this.size, this.value).subscribe(
      (res: any) => {


        this.empty = res['data']['empty']
        this.pageSize = res['data']['totalPages']

        this.totalNumberOfElements = res['data']['numberOfElements'] - 1;
        this.homePageProduct = res['data']['content'];

        console.log("the homepageproduct is", this.homePageProduct);


        this.total = res['data']['totalElements'] - 1;
        this.dataLoaded = true;
        this.cdr.detectChanges();


        // this.updateMetaTags();

      },
      (error) => {
        console.error('Error loading home page data:', error);
        this.dataLoaded = true; // Still set to true to show empty state
      }
    )
  }

  navigateToGetStarted() {
  window.location.href = 'https://ecom.dspeedup.in/register';
}


navigateToConnect() {
  this.navigate(); // Call the WhatsApp navigation function
}


storePhoneNumber: any ; // Set your default number here

navigate() {
  const message = `Hi `;
  const currentURL = window.location.href;
  const encodedURL = encodeURIComponent(currentURL);
  const phone = "919444860882";
  const text = encodeURIComponent(message) + encodedURL;

  const url = `https://api.whatsapp.com/send?phone=${phone}&text=${text}`;
  console.log("the url",url);
  

  this.analyticService.customEventEmitter('WA_button_Clicked', 'BUTTON_CLICK', 'Whats App Click', url);

  this.commonService.goToLink(url);
  window.open(url, '_blank');
}



  LogoSlider = {
    nav: false,
    dots: false,
    items: 1,
    margin: 20,
    loop: false,
    autoHeight: true,
    autoplay: true,
    
    responsive: {
        767: {
            items: 1
        },
        576: {
            items: 1
        },
        480: {
            items: 1
        },
        0: {
            items: 1
        }
    }
}

LogoSlider1 = {
  nav: false,
  dots: false,
  items: 1,
  margin: 20,
  loop: true,
  autoHeight: true,
  autoplay: true,
  
  responsive: {
      767: {
          items: 4
      },
      576: {
          items: 4
      },
      480: {
          items: 2
      },
      0: {
          items: 2
      }
  }
}

 imageNavigation(id :any){


    if(id>0){
      this.commonService.goToCategory(1, parseInt(id));
    }

  }

  link(url :any) {

  this.commonService.goToLink(url)
 
}

scroll(id :any) {

  this.commonService.scrollDown(id)
 
}
imagesToShow = 2; // Initial number of images to show
loadMoreStep = 2; // Number of images to load each time "Load More" is clicked

  onLoadMore() {
    this.imagesToShow += this.loadMoreStep;
  }


goToCategories(id: any) {
  
    if(id>0){
      this.commonService.goToCategory(1, parseInt(id));
    }
    else{
        this.commonService.goToLink(id);
  
    }
   
  }
  dynamicFormPopup(formGroupId:any) {
    if (window.innerWidth > 768) {

       let dialogRef = this.dialog.open(FormPopupComponent, {
          width: '790px',
          data: { formId: formGroupId}
       });

       dialogRef.disableClose = true;
       dialogRef.afterClosed().subscribe(() => {

       });

    }
    else {
       let dialogRef = this.dialog.open(FormPopupComponent, {
          minWidth: '100vw', height: '100vh',
          data: { formId: formGroupId}
       });

       dialogRef.disableClose = true;
       dialogRef.afterClosed().subscribe(() => {

       });
    }

 }
 
 openInNewWindow(url: string) {
  if (url) {
    this.commonService.goToLink(url)
  }
}
trackByFn(item: any): any {
  return item.position; // or return item.id; if you have a unique identifier
}

trackImgByFn(item: any): any {
  return item.images.valueId; // or return item.id; if you have a unique identifier
}

  TextwithFormPopup(data:any) {
    // if (window.innerWidth > 768) {

    //    let dialogRef = this.dialog.open(TextwithformPopupComponent, {
    //       width: '850px',
    //       data: { item: data}
    //    });

    //    dialogRef.disableClose = true;
    //    dialogRef.afterClosed().subscribe(() => {

    //    });

    // }
    // else {
    //    let dialogRef = this.dialog.open(TextwithformPopupComponent, {
    //       minWidth: '100vw', height: '100vh',
    //       data: { item: data}
    //    });

    //    dialogRef.disableClose = true;
    //    dialogRef.afterClosed().subscribe(() => {

    //    });
    // }

 }

  shouldHideContainer(): boolean {
    const url = this.router.url.toLowerCase();
    return /thank[-]?you/.test(url); // Matches "thankyou" or "thank-you"
  }

  shouldApplyContainer(item: any): boolean {
  const excludedRoutes = [
    '/customizable-crm-for-small-business',
    '/whatsapp-crm-solution-india',
    '/calsoft-crm'
  ];

  const currentUrl = this.router.url;

  // Check the item.customField23 condition AND if current route is not excluded
  return (
    item.customField23 !== '6' &&
    item.customField23 !== '11' &&
    item.customField23 !== '12' &&
    item.customField23 !== '22' &&
    !excludedRoutes.includes(currentUrl)
  );
}
}
